import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from './../../../layout/layout.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CrmService } from './../crm.service';
import { Component, OnInit } from '@angular/core';
import { timeStamp } from 'console';

@Component({
  selector: 'app-create-campaign',
  templateUrl: './create-campaign.component.html',
  styleUrls: ['./create-campaign.component.scss'],
})
export class CreateCampaignComponent implements OnInit {
  bpFilterFields = [];
  leadFilterFields = [];
  itemFilterFields = [];

  savedFilterQueryId = 2620;
  newsLettersListQueryId = 2629;
  templatesListQueryId = 2622;
  sendersListQueryId = 2623;
  ownersListQueryId = 2624;
  savedFilterList: any[];
  newsLettersList = [];
  templatesList = [];
  sendersList = [];
  ownersList = [];
  selectedFilter = '';
  filterName = '';
  filterObject: { BPInfo: any[]; LeadInfo: any[]; ItemInfo: any[] } = {
    BPInfo: [],
    LeadInfo: [],
    ItemInfo: [],
  };
  campaignObject: {
    AttachNames: any[];
    AttachData: any[];
    SelectedContacts: any[];
    SelectedBPs: any[];
    SelectedLeads: any[];
    DefaultActivityCreate: boolean;
    TolerTime: number;
  } = {
    AttachNames: [],
    AttachData: [],
    SelectedContacts: [],
    SelectedBPs: [],
    SelectedLeads: [],
    DefaultActivityCreate: true,
    TolerTime: 5,
  };
  attachmentUpload = [];

  compareOperations = [
    { Code: 'E', Title: 'Equal' },
    { Code: 'NE', Title: 'Not Equal' },
    { Code: 'GT', Title: 'Greater Than' },
    { Code: 'ST', Title: 'Smaller Than' },
    { Code: 'I', Title: 'In' },
    { Code: 'NI', Title: 'Not In' },
    { Code: 'BET', Title: 'Between' },
    { Code: 'LIKE', Title: 'Like' },
  ];

  targetGroupCols = [];
  headerFilter = [];
  selectedCount = 0;
  pageSize = '25';
  currentStep = 0;
  maxStepCount = 3;
  currentPage = 1;
  totalPageCount = 0;
  targetGroupData = [];

  constructor(
    private crmSerice: CrmService,
    private layoutService: LayoutService,
    private modal: NzModalService,
    private message: NzMessageService
  ) {}

  ngOnInit() {
    this.filterObject.BPInfo = [];
    this.filterObject.LeadInfo = [];
    this.filterObject.ItemInfo = [];

    this.campaignObject.AttachNames = [];
    this.campaignObject.AttachData = [];
    this.campaignObject.SelectedContacts = [];
    this.campaignObject.SelectedBPs = [];
    this.campaignObject.SelectedLeads = [];
    this.campaignObject.DefaultActivityCreate = true;
    this.campaignObject.TolerTime = 5;

    this.loadFilterField('bp');
    this.loadFilterField('lead');
    this.loadFilterField('item');

    this.loadData(this.savedFilterQueryId, false, '', 'SavedFilterList');
    this.loadData(this.newsLettersListQueryId, false, '', 'NewsLettersList');
    this.loadData(this.templatesListQueryId, false, '', 'TemplatesList');
    this.loadData(this.sendersListQueryId, false, '', 'SendersList');
    this.loadData(this.ownersListQueryId, false, '', 'OwnersList');

    this.getTargetGroupCols();
  }

  loadFilterField(criteria) {
    var criteriaNumber = 0;
    if (criteria == 'bp') {
      criteriaNumber = 1;
    } else if (criteria == 'lead') {
      criteriaNumber = 2;
    } else if (criteria == 'item') {
      criteriaNumber = 3;
    }

    this.crmSerice.getFilterFields(criteriaNumber).subscribe((d: any) => {
      console.log({ d });
      if (criteria == 'bp') {
        this.bpFilterFields = Object.assign([], d.result);
      } else if (criteria == 'lead') {
        this.leadFilterFields = Object.assign([], d.result);
      } else if (criteria == 'item') {
        this.itemFilterFields = Object.assign([], d.result);
      }
    });
  }

  loadData(
    queryId: number,
    takeFirstLine: boolean,
    currentObjectVal: string,
    arrayName: string
  ) {
    this.crmSerice.loadData(queryId, currentObjectVal).subscribe((d: any) => {
      console.log({ loadData: d });
      let arrayToSave: any[];
      if (d.length !== 0) {
        if (takeFirstLine) {
          arrayToSave = Object.assign([], d.rows[0]);
        } else {
          arrayToSave = Object.assign([], d.rows);
        }

        if (arrayName === 'SavedFilterList') {
          this.savedFilterList = arrayToSave;
        } else if (arrayName === 'NewsLettersList') {
          this.newsLettersList = arrayToSave;
        } else if (arrayName === 'TemplatesList') {
          this.templatesList = arrayToSave;
        } else if (arrayName === 'SendersList') {
          this.sendersList = arrayToSave;
        } else if (arrayName === 'OwnersList') {
          this.ownersList = arrayToSave;
        }
      }
    });
  }

  getTargetGroupCols() {
    this.crmSerice.getTargetGroupCols().subscribe((d: any) => {
      console.log({ getTargetGroupCols: d });
      if (d.cols != undefined && d.cols != '') {
        this.targetGroupCols = JSON.parse(d.cols);
        for (var i = 0; i < this.targetGroupCols.length; i++) {
          if (this.targetGroupCols[i].Filterable) {
            this.headerFilter[this.targetGroupCols[i].Name] = '';
          }
        }
      }
    });
  }

  pervStep() {
    if (this.currentStep !== 0) {
      this.currentStep--;
    }
  }

  nextStep() {
    if (this.currentStep < 3) {
      this.currentStep += 1;
    }
    if (this.currentStep == 2) {
      //this.ApplyFilter();
    }
    if (this.currentStep == 3) {
      if (this.selectedCount == 0) {
        this.message.error(this.layoutService.translate('There is no contacts selected'));
        this.currentStep = 2;
        return;
      }
      //this.SaveCampaign();
    }
  }

  loadFilter(filterId: string, filterName: string) {
    this.selectedFilter = filterId;
    this.filterObject = {
      BPInfo: [],
      LeadInfo: [],
      ItemInfo: [],
    };
    this.filterObject.BPInfo = [];
    this.filterObject.LeadInfo = [];
    this.filterObject.ItemInfo = [];
    if (filterId == undefined || filterId == '') {
      this.filterName = '';
      return;
    }

    this.filterName = filterName;

    this.crmSerice.loadFilter(filterId).subscribe((d: any) => {
      this.filterObject = JSON.parse(d.Resault_Value);
      console.log(this.filterObject);
      this.fixFilterData();
      console.log(this.filterObject);
    });
  }

  fixFilterData = function () {
    for (var i = 0; i < this.filterObject.BPInfo.length; i++) {
      var orList = Object.assign([], this.filterObject.BPInfo[i]);
      for (var j = 0; j < orList.length; j++) {
        var subFilter = Object.assign([], orList[j]);
        if (subFilter.DataType == 3) {
          // date
          subFilter.FieldValue = new Date(subFilter.FieldValue);
          subFilter.FieldValueTo = new Date(subFilter.FieldValueTo);
        }
      }
    }

    for (var i = 0; i < this.filterObject.LeadInfo.length; i++) {
      var orList = Object.assign([], this.filterObject.LeadInfo[i]);
      for (var j = 0; j < orList.length; j++) {
        var subFilter = Object.assign([], orList[j]);
        if (subFilter.DataType == 3) {
          // date
          subFilter.FieldValue = new Date(subFilter.FieldValue);
          subFilter.FieldValueTo = new Date(subFilter.FieldValueTo);
        }
      }
    }

    for (var i = 0; i < this.filterObject.ItemInfo.length; i++) {
      var orList = Object.assign([], this.filterObject.ItemInfo[i]);
      for (var j = 0; j < orList.length; j++) {
        var subFilter = Object.assign([], orList[j]);
        if (subFilter.DataType == 3) {
          // date
          subFilter.FieldValue = new Date(subFilter.FieldValue);
          subFilter.FieldValueTo = new Date(subFilter.FieldValueTo);
        }
      }
    }
  };

  changeFilterType(subFilter) {
    console.log(subFilter);
    subFilter.FieldValue = '';
    subFilter.FieldValueTo = '';
    subFilter.Options = [];
    var filterField =
      this.bpFilterFields[
        this.bpFilterFields.findIndex((item) => item.Id == subFilter.FieldId)
      ];
    if (filterField == undefined)
      filterField =
        this.leadFilterFields[
          this.leadFilterFields.findIndex(
            (item) => item.Id == subFilter.FieldId
          )
        ];
    if (filterField == undefined)
      filterField =
        this.itemFilterFields[
          this.itemFilterFields.findIndex(
            (item) => item.Id == subFilter.FieldId
          )
        ];
    subFilter.DataType = filterField.DataType;
    subFilter.Options = Object.assign([], filterField.Options);
    if (subFilter.DataType === 5) {
      subFilter.FieldValue = [];
      subFilter.FieldValueTo = [];
    }

    console.log(subFilter);
  }

  deleteFilter(code) {
    this.modal.confirm({
      nzTitle: this.layoutService.translate('are you sure?'),
      nzContent: '',
      nzOnOk: () => {
        this.crmSerice.deleteFilter(code).subscribe((d: any) => {
          if (!d.Has_Error) {
            this.loadData(
              this.savedFilterQueryId,
              false,
              '',
              'SavedFilterList'
            );
            this.selectedFilter = d.Resault_Value;

            this.message.success(
              this.layoutService.translate(
                'Your operation has been completed successfully!'
              )
            );
            this.loadFilter('', '');
          } else {
            this.message.error(d.Error_Message);
          }
        });
      },
    });
  }

  removeOrList(criteria, index) {
    if (criteria == 'bp') {
      this.filterObject.BPInfo.splice(index, 1);
    } else if (criteria == 'lead') {
      this.filterObject.LeadInfo.splice(index, 1);
    } else if (criteria == 'item') {
      this.filterObject.ItemInfo.splice(index, 1);
    }
  }

  removeCondition(criteria, parentIndex, index) {
    if (criteria == 'bp') {
      this.filterObject.BPInfo[parentIndex].splice(index, 1);
    } else if (criteria == 'lead') {
      this.filterObject.LeadInfo[parentIndex].splice(index, 1);
    } else if (criteria == 'item') {
      this.filterObject.ItemInfo[parentIndex].splice(index, 1);
    }
  }

  addAndList(criteria, index) {
    var newAndCond = {
      FieldId: -1,
      FilterOpr: 'E',
      FieldValue: '',
      FieldValueTo: '',
      DataType: '1',
      Options: [],
    };
    if (criteria == 'bp') {
      this.filterObject.BPInfo[index].push(newAndCond);
    } else if (criteria == 'lead') {
      this.filterObject.LeadInfo[index].push(newAndCond);
    } else if (criteria == 'item') {
      this.filterObject.ItemInfo[index].push(newAndCond);
    }
  }

  addOrList(criteria) {
    var newORList = [
      {
        FieldId: -1,
        FilterOpr: 'E',
        FieldValue: '',
        FieldValueTo: '',
        DataType: '1',
        Options: [],
      },
    ];
    if (criteria == 'bp') {
      this.filterObject.BPInfo.push(newORList);
    } else if (criteria == 'lead') {
      this.filterObject.LeadInfo.push(newORList);
    } else if (criteria == 'item') {
      this.filterObject.ItemInfo.push(newORList);
    }
  }

  applyFilter() {
    this.targetGroupData = [];
    this.campaignObject.SelectedContacts = [];
    this.campaignObject.SelectedBPs = [];
    this.campaignObject.SelectedLeads = [];
    this.selectedCount = 0;
  }
}
